const Path = {
  games: "",
  login: "login",
  register: "register",
  forgotPassword: "forgot-password",
  changePassword: "change-password",
  resetPassword: "reset-password",
};
export default Path;
